import LotTitle from './lot-title';
export default LotTitle;